import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShape = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	width: 24,
	height: 24,
	strokeWidth: 1.5,
	"data-darkreader-inline-stroke": "",
	style: { "--darkreader-inline-stroke": "currentColor" },
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M5 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M19 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M5 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M19 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M5 7l0 10" }),
		/* @__PURE__ */ _jsx("path", { d: "M7 5l10 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M7 19l10 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M19 7l0 10" })
	]
});
const ForwardRef = forwardRef(SvgShape);
export default ForwardRef;
